import {Plan} from "../../../types";
import getMaxAllowedManholeCount, {LimitingReason} from "../../../containers/domain/getMaxAllowedManholeCount";

export type ManholeCountValidationResult = {
    ok: boolean;
    maxManholeCount: number;
    manholeCount: number;
    manholeIds: string[];
    limitingReason: LimitingReason;
}

export const validateManholeCount = (plan: Plan): ManholeCountValidationResult => {
    const [maxManholeCount, reason] = getMaxAllowedManholeCount(plan)
    const manholes = plan.lid?.manholes ?? [];
    const manholeCount = manholes.length;

    return manholeCount > maxManholeCount
        ? {ok: false, maxManholeCount, manholeCount, manholeIds: manholes.map(m => m.id), limitingReason: reason}
        : {ok: true, maxManholeCount, manholeCount, manholeIds: [], limitingReason: reason}
}
